import $ from 'jquery';
import Header from "./widgets/header"
import NewHeader from "./widgets/new-header";
import LoginButton from "./modules/login-button";
import NewsletterUnsubscribe from "./widgets/newsletter-unsubscribe";
import ContactForm from "./widgets/contact-form";
import domEvents from "./modules/dom-events";
import AccountSavedArticless from "./widgets/account-saved-articles";
import AccountSearchFavoriteArticles from "./widgets/account-search-favorite-articles";
import VideoConsultas from "./widgets/video-consultas";
import AccountComplete from "./widgets/account-complete";

new Header();
new NewHeader();
domEvents.init();

$('[data-login-show]').each(function(){
    new LoginButton(this);
});

$('[data-account_complete-container]').each(function () {
    new AccountComplete(this);
});

document.addEventListener("DOMContentLoaded", function(){
    new NewsletterUnsubscribe();
});

$('[data-id="contact-form"]').each(function () {
    new ContactForm(this);
});

new VideoConsultas($('[data-id="video-consulta-render"]'));

$('[data-id="accountsavedarticles"]').each(function () {
    new AccountSavedArticless(this)
});

$('[data-id="searchFavoritesForm"]').each(function () {
    new AccountSearchFavoriteArticles(this)
});